/**
 * Header search: All Products / Physical / Digital via Purchase Type filter.
 * Keeps Empire SearchForm q clean (no product_type: prefix) and applies the
 * storefront filter query param on submit + predictive-search suggest fetches.
 */
(function () {
  function selectedPurchaseType(select) {
    const option = select.options[select.selectedIndex];
    return (option && option.getAttribute('data-og-purchase-type')) || '';
  }

  function syncPurchaseTypeInput(select) {
    const form = select.closest('[data-og-purchase-type-form]');
    if (!form) return;

    const param = select.getAttribute('data-og-purchase-filter-param');
    if (!param) return;

    let input = form.querySelector('[data-og-purchase-type-input]');
    const purchaseType = selectedPurchaseType(select);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-og-purchase-type-input', '');
      form.appendChild(input);
    }

    input.name = param;
    if (purchaseType) {
      input.value = purchaseType;
      input.disabled = false;
    } else {
      input.value = '';
      input.disabled = true;
    }

    const label = form.querySelector('[data-live-search-filter-label]');
    const option = select.options[select.selectedIndex];
    if (label && option) {
      label.textContent = option.textContent.trim();
    }

    form.classList.toggle('live-search-filter-active', Boolean(purchaseType));
  }

  function bindSelect(select) {
    if (select.getAttribute('data-og-purchase-type-bound')) return;
    select.setAttribute('data-og-purchase-type-bound', 'true');
    syncPurchaseTypeInput(select);
  }

  function bindAll() {
    document.querySelectorAll('[data-og-purchase-type-select]').forEach(bindSelect);
  }

  function activePurchaseFilter() {
    const select = document.querySelector('[data-og-purchase-type-select]');
    if (!select) return null;
    const purchaseType = selectedPurchaseType(select);
    const param = select.getAttribute('data-og-purchase-filter-param');
    if (!purchaseType || !param) return null;
    return { param: param, value: purchaseType };
  }

  function withPurchaseTypeFilter(url) {
    const filter = activePurchaseFilter();
    if (!filter) return url;

    try {
      const parsed = new URL(url, window.location.origin);
      if (!parsed.pathname.includes('/search/suggest') && !parsed.pathname.endsWith('/search')) {
        return url;
      }
      parsed.searchParams.delete(filter.param);
      // Clear any stale purchase-type filter keys if param name differs
      Array.from(parsed.searchParams.keys()).forEach(function (key) {
        const lower = key.toLowerCase();
        if (
          lower !== filter.param.toLowerCase() &&
          (lower.indexOf('fulfillment') !== -1 || lower.indexOf('purchase_type') !== -1 || lower.indexOf('purchasetype') !== -1)
        ) {
          parsed.searchParams.delete(key);
        }
      });
      parsed.searchParams.set(filter.param, filter.value);
      return parsed.toString();
    } catch (e) {
      return url;
    }
  }

  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      let url = input;
      if (typeof input === 'string') {
        url = withPurchaseTypeFilter(input);
      } else if (input && typeof input.url === 'string') {
        const next = withPurchaseTypeFilter(input.url);
        if (next !== input.url && typeof Request === 'function') {
          url = new Request(next, input);
        }
      }
      return originalFetch.call(this, url, init);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', bindAll);

  // Run after Empire's select handler, which treats our empty option values
  // as "All Products" and otherwise overwrites the selected option's label.
  document.addEventListener('change', function (event) {
    const select = event.target;
    if (select.matches('[data-og-purchase-type-select]')) {
      syncPurchaseTypeInput(select);
    }
  });
})();
